import { cn } from '@/lib/utils'

export const LoadingSpinner = ({
  fullscreen = true,
  className,
}: {
  fullscreen?: boolean
  className?: string
}) => (
  <div
    className={cn(
      'flex items-center justify-center',
      {
        'h-screen w-full': fullscreen,
      },
      className
    )}
  >
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="animate-spin text-primary"
    >
      <path d="M21 12a9 9 0 1 1-6.219-8.56" />
    </svg>
  </div>
)
